import styled, { css } from "styled-components";

import { getMd3TypographyCss } from "../../styles/md3Components";
import { fontSizes } from "../../styles/typography";
import type { Md3Expressive } from "../../../theme/md3Expressive";

type TypographyRole = keyof Md3Expressive["typography"];

const roleStyles = (role: TypographyRole) => css`
  ${({ theme }) => getMd3TypographyCss(theme, role)}
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

export const DisplayMedium = styled.h1<{ $role?: never }>`
  ${roleStyles("displayMedium")}
`;

export const HeadlineLarge = styled.h1`
  ${roleStyles("headlineLarge")}
`;

export const HeadlineMedium = styled.h2`
  ${roleStyles("headlineMedium")}
`;

export const TitleLarge = styled.h3`
  ${roleStyles("titleLarge")}
`;

export const TitleMedium = styled.h4`
  ${roleStyles("titleMedium")}
`;

export const BodyLarge = styled.p`
  ${roleStyles("bodyLarge")}
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const BodyMedium = styled.p`
  ${roleStyles("bodyMedium")}
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LabelLarge = styled.span`
  ${roleStyles("labelLarge")}
`;

export const LabelMedium = styled.span`
  ${roleStyles("labelMedium")}
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SectionTitle = styled.h3`
  ${roleStyles("titleLarge")}
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const TitleBadge = styled.span`
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 2px 10px;
  border-radius: ${({ theme }) => theme.borderRadius.md}px;
  font-size: ${fontSizes.sm}px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
`;
